module.exports = __webpack_public_path__ + "306169f5f60566022d8a09bdc5ed6a6c.MP3";